"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getUserResponse = exports.getUserEpic = exports.getUserAjax = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _operators = require("rxjs/operators");

var _map = require("rxjs/operators/map");

var _observableErrorHandler = require("../../../redux/observableErrorHandler");

var _models = require("../../models");

var _userApi = require("../userApi");

var _userRegistry = require("../userRegistry");

var getUserAjax = function getUserAjax(ajax) {
  return ajax({
    method: 'GET',
    url: _userApi.getUserApiUrl
  }).pipe((0, _mapInstanceProperty(_map))(function (payload) {
    return payload.response;
  }));
};

exports.getUserAjax = getUserAjax;

var getUserEpic = function getUserEpic(action$, _store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(_models.UserActions.getUser).pipe((0, _operators.switchMap)(function (action) {
    return getUserAjax(ajax).pipe((0, _mapInstanceProperty(_map))(function (userPerson) {
      return {
        type: _models.UserActions.getUserResponse,
        payload: userPerson
      };
    }), (0, _operators.catchError)((0, _observableErrorHandler.errorHandler)(_models.UserActions.getUserFailed, action)));
  }));
};

exports.getUserEpic = getUserEpic;

_userRegistry.userRegistry.addEpic('getUser', getUserEpic);

var getUserResponse = function getUserResponse(state, action) {
  if (action.payload === undefined) {
    return state;
  }

  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    userPerson: action.payload
  });
  return nextState;
};

exports.getUserResponse = getUserResponse;

_userRegistry.userRegistry.add(_models.UserActions.getUserResponse, getUserResponse);